import { n__, s__ } from '~/locale';

// Shared sortablejs group so cards can be dragged between every column.
export const BOARD_DND_GROUP = 'work-item-board';

// Class applied to each draggable card so the load-more row stays fixed.
export const BOARD_CARD_CLASS = 'js-board-card';

// Classes on each column's card list and each card's link, used to move focus
// between cards with the arrow keys.
export const BOARD_CARD_LIST_CLASS = 'js-board-card-list';
export const BOARD_CARD_LINK_CLASS = 'js-board-card-link';
export const BOARD_COLUMN_BODY_CLASS = 'js-board-column-body';

// Class applied to the card left behind in the target slot while dragging,
// restyled from a card into an insertion line (see page_bundles/work_items.scss).
export const BOARD_CARD_DROP_INDICATOR_CLASS = 'board-card-drop-indicator';

// Separate sortablejs group for column reordering, so columns and cards can
// never be dropped into each other's lists.
export const BOARD_COLUMN_DND_GROUP = 'work-item-board-columns';

// Class marking each draggable column, and the header grip you have to grab to
// start dragging it (so dragging a card inside the column doesn't move the column).
export const BOARD_COLUMN_CLASS = 'js-board-column';
export const BOARD_COLUMN_DRAG_HANDLE_CLASS = 'js-board-column-drag-handle';

// Header controls (like the column actions menu) that live inside the drag
// handle but shouldn't trigger a column drag when clicked.
export const BOARD_COLUMN_NO_DRAG_CLASS = 'js-board-column-no-drag';

// The card's actions menu lives inside the draggable card itself, so it needs
// its own filter to keep opening it from starting a card drag.
export const BOARD_CARD_NO_DRAG_CLASS = 'js-board-card-no-drag';

export const I18N_MOVE_ERROR = s__(
  'WorkItemBoard|Something went wrong while updating the work item. Please try again.',
);

export const I18N_MOVE_SUCCESS = s__('WorkItemBoard|Moved %{reference} to %{targetGroup}');

export const I18N_MOVE_TO_START_SUCCESS = s__(
  'WorkItemBoard|Moved %{reference} to the start of %{groupName}',
);

export const I18N_MOVE_TO_END_SUCCESS = s__(
  'WorkItemBoard|Moved %{reference} to the end of %{groupName}',
);

export const I18N_GROUP_MOVED = s__('WorkItemBoard|Moved %{groupName}');

export const I18N_GROUP_HIDDEN = s__('WorkItemBoard|%{groupName} list hidden');

export const i18nItemsLoaded = (count) =>
  n__(
    'WorkItemBoard|Loaded %{count} more item in %{groupName}',
    'WorkItemBoard|Loaded %{count} more items in %{groupName}',
    count,
  );

export const I18N_GROUP_MOVED_LEFT = s__('WorkItemBoard|Moved %{groupName} left');

export const I18N_GROUP_MOVED_RIGHT = s__('WorkItemBoard|Moved %{groupName} right');

// How long the drag lock must be held before we show a busy indicator for it,
// so brief moves don't cause a flash of greyed-out columns.
export const MOVE_IN_PROGRESS_INDICATOR_DELAY = 1000;
